module.exports = __webpack_public_path__ + "img/right.4e913994.png";